import { useMemo } from 'react';

export const useLikesCount = (count: number) => useMemo(() => {
  const k = 1000;
  const m = k*k;

  if (count < k) {
    return count;
  } else if (count < 10 * k) {
    return `${parseFloat((count / k).toFixed(2))}k`
      .replace('.', ',');
  } else if (count < 100 * k) {
    return `${parseFloat((count / k).toFixed(1))}k`
      .replace('.', ',');
  } else if (count < m) {
    return `${Math.round(count / k)}k`;
  } else if (count < 10 * m) {
    return `${parseFloat((count / m).toFixed(2))}m`
      .replace('.', ',');
  } else if (count < 100 * m) {
    return `${parseFloat((count / m).toFixed(1))}m`
      .replace('.', ',');
  }
  return `${Math.round(count / m)}m`;
}, [ count ]);
